import React from "react";
import { useOutletContext } from "react-router-dom";
import { GdprPanel } from "../components/gdpr-panel.jsx";
import type { AdminOutletContext } from "../lib/outlet-context";

export function InfrastructureGdprPage() {
  const { clients, api } = useOutletContext<AdminOutletContext>();
  return <GdprPanel clients={clients} api={api} />;
}
